import { VERSION, REVISION } from '../consts/version';

jQuery(document).ready(function ($) {
    $(window).on('load', function () {
        //Version set start
        $('#version-number').html(`v${VERSION} (${REVISION})`);
        $('#version-number-2').html(`v${VERSION} (${REVISION})`);
        //Version set end
    });

    $(function () {
        $('.lazy').lazy();
    });

    if ($('.b-footer-container >a').html()) {
        if (!$('.b-footer-container >a').html().replace(/ /g, '')) {
            $('.b-footer-container >a').remove();
        }
    }
});
